// ADR 0023 Sprint 7 Wave B — Platform management layout wrapper.
//
// Wraps all /platform/* routes. Provides:
//   1. <TenantSelectorBand> — the tenant switcher header band (inline variant).
//   2. <Outlet> — renders the matched child route.
//
// This component is mounted as a nested layout route by the router:
//   {
//     path: '/platform',
//     element: <RequirePlatformAdminRoute />,  // gates on Me.is_platform_admin
//     children: [
//       { element: <PlatformLayout />, children: [...child routes] }
//     ]
//   }
//
// Phase 3 (tenant-view switcher): PlatformTenantProvider is now promoted to the
// AppShell level (wraps ALL authenticated routes). This layout no longer creates
// its own nested provider — it uses the outer provider from context. Removing the
// inner provider prevents the double-provider bug where the inner context's
// useEffect would race the outer context's useEffect on mount, causing
// inconsistent store state between the two provider instances.
//
// The outer RequirePlatformAdminRoute in the router handles the 403 case.
// TenantSelectorBand has its own useIsPlatformAdmin guard for belt-and-suspenders.
import { Outlet } from 'react-router-dom'
import { TenantSelectorBand } from './TenantSelectorBand'

export function PlatformLayout() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <TenantSelectorBand />
      <div className="flex-1 overflow-auto p-6">
        <Outlet />
      </div>
    </div>
  )
}
